import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import injectStyles from 'react-jss'
import styles from '../styles'
import DeleteIcon from '../../../../Assets/Images/icons/delete'

const ChatConversationItemView = ({
  name,
  lastMessageText,
  lastMessageTime,
  onClick,
  onArchive,
  classes,
  isActive,
  isCityBased,
  isUnread,
  archived,
}) => {
  const wrapperStyle = () => {
    if (isActive) {
      return classNames(classes.wrapper, classes.activeWrapper)
    }
    if (isUnread) {
      return classNames(classes.wrapper, classes.unreadWrapper)
    }
    return classes.wrapper
  }
  return (
    <article className={wrapperStyle()} onClick={onClick}>
      {!archived && (
        <div onClick={onArchive} className={classes.leftTopIcon}>
          <DeleteIcon width={10} height={10} />
        </div>
      )}
      <div className={classes.textWrapper}>
        <span className={classes.title}>{name}</span>
        <span className={classes.description}>{lastMessageText}</span>
      </div>
      <div className={classes.rightBottomText}>
        <span>{lastMessageTime}</span>
      </div>
    </article>
  )
}

ChatConversationItemView.propTypes = {
  classes: PropTypes.object,
  name: PropTypes.string,
  lastMessage: PropTypes.string,
  lastMessageTime: PropTypes.string,
  onClick: PropTypes.func,
  onArchive: PropTypes.func,
  isActive: PropTypes.bool,
}

export default injectStyles(styles)(ChatConversationItemView)



// WEBPACK FOOTER //
// ./src/Components/Chat/ChatConversationItem/component/ChatConversationItemView.js